import { StyleSheet } from 'react-native';
export default StyleSheet.create({
  tableCell: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  cellValue: {
    color: '#333',
    fontSize: 13,
    fontWeight: '400',
  },

  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,    
  },

  modalContent: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 20,
    maxWidth: 400,
    width: '100%',
    maxHeight: '80%',
  },

  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
    paddingBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#e9ecef',
  },

  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginLeft: 12,
  },

  detailsTable: {
    marginBottom: 20,
  },

  tableRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },

  tableCellTitle: {
    flex: 1.5,    
  },

  headerText: {
    color: '#00448F',
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
  },

  cellText: {
    color: '#666',
    fontSize: 14,
  },

  closeButton: {
    backgroundColor: '#00448F',
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    alignItems: 'center',
    marginTop: 10,
  },

  closeButtonText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 16,
  },
});